export default __webpack_public_path__ + "static/media/ic_baseline-list-alt.01d32a9d.svg";